import Layout from "@/views/layout/layout";
const rootPath = "/pame";

const payment = {
  path: rootPath,
  name: "payment",
  description: "결제",
  redirect: rootPath + "/napasQR",
  component: Layout,
  children: [
    {
      path: "napasQR",
      name: "napasQR",
      redirect: { name: "napasQrPaymentStep1" },
      component: () => import("@/views/templates/payment/napasQr"),
      children: [
        {
          path: "napasQrPaymentStep1",
          name: "napasQrPaymentStep1",
          description: "Static QR결제 Step1",
          component: () => import("@/views/templates/payment/napasQrPaymentStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "napasQrPaymentStep2",
          name: "napasQrPaymentStep2",
          description: "QR결제 Step2(당행)",
          component: () => import("@/views/templates/payment/napasQrPaymentStep2"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 2,
          },
        },
        {
          path: "napasQrPaymentStep2",
          name: "napasQrPaymentOtrbnkStep2",
          description: "QR결제 Step2(타행)",
          component: () => import("@/views/templates/payment/napasQrPaymentOtrbnkStep2"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 2,
          },
        },
        {
          path: "napasQrPaymentStep3",
          name: "napasQrPaymentStep3",
          description: "QR결제 Step3",
          component: () => import("@/views/templates/payment/napasQrPaymentStep3"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 3,
            isLast: true,
          },
        },
        {
          path: "myQr",
          name: "myQr",
          description: "My QR",
          component: () => import("@/views/templates/payment/myQr"),
          meta: {
            roles: ["login"],
          },
        },
        {
          path: "qrUnderApproval",
          name: "qrUnderApproval",
          description: "QR결제내역",
          component: () => import("@/views/templates/payment/qrUnderApproval"),
          meta: {
            roles: ["login"],
          },
        },
        {
          path: "paymentHistory",
          name: "paymentHistory1",
          description: "결제내역",
          component: () => import("@/views/templates/payment/paymentHistory"),
          meta: {
            roles: ["login"],
            svcDstcd: "0",
          },
        },
      ],
    },
    {
      name: "phoneTopupReq",
      path: "phoneTopupReq",
      redirect: { name: "phoneTopupReqStep1" },
      component: () => import("@/views/templates/payment/phoneTopupReq"),
      children: [
        {
          path: "step1",
          name: "phoneTopupReqStep1",
          description: "휴대폰충전-step1",
          component: () => import("@/views/templates/payment/phoneTopupReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "phoneTopupReqStep2",
          description: "휴대폰충전-step2",
          component: () => import("@/views/templates/payment/phoneTopupReqStep2"),
          meta: {
            roles: ["login"],
            transparent: true,
            firstPage: "phoneTopupReq",
            step: 2,
          },
        },
        {
          path: "step3",
          name: "phoneTopupReqStep3",
          description: "휴대폰충전-step3",
          component: () => import("@/views/templates/payment/phoneTopupReqStep3"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 3,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "phoneTopupApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "paymentHistory",
          name: "paymentHistory2",
          description: "결제내역",
          component: () => import("@/views/templates/payment/paymentHistory"),
          meta: {
            roles: ["login"],
            svcDstcd: "2",
          },
        },
      ],
    },
    {
      name: "electricityPaymentReq",
      path: "electricityPaymentReq",
      redirect: { name: "electricityPaymentReqStep1" },
      component: () => import("@/views/templates/payment/electricityPaymentReq"),
      children: [
        {
          path: "step1",
          name: "electricityPaymentReqStep1",
          description: "전기요금납부-step1",
          component: () => import("@/views/templates/payment/electricityPaymentReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "electricityPaymentReqStep2",
          description: "전기요금납부-step2",
          component: () => import("@/views/templates/payment/electricityPaymentReqStep2"),
          meta: {
            roles: ["login"],
            transparent: true,
            firstPage: "billPaymentMain",
            step: 2,
          },
        },
        {
          path: "step3",
          name: "electricityPaymentReqStep3",
          description: "전기요금납부-step3",
          component: () => import("@/views/templates/payment/electricityPaymentReqStep3"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 3,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "electricityPaymentApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      name: "waterPaymentReq",
      path: "waterPaymentReq",
      redirect: { name: "waterPaymentReqStep1" },
      component: () => import("@/views/templates/payment/waterPaymentReq"),
      children: [
        {
          path: "step1",
          name: "waterPaymentReqStep1",
          description: "수도요금납부-step1",
          component: () => import("@/views/templates/payment/waterPaymentReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "waterPaymentReqStep2",
          description: "수도요금납부-step2",
          component: () => import("@/views/templates/payment/waterPaymentReqStep2"),
          meta: {
            roles: ["login"],
            transparent: true,
            firstPage: "billPaymentMain",
            step: 2,
          },
        },
        {
          path: "step3",
          name: "waterPaymentReqStep3",
          description: "수도요금납부-step3",
          component: () => import("@/views/templates/payment/waterPaymentReqStep3"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 3,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "waterPaymentApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "billPaymentMain",
      name: "billPaymentMain",
      component: () => import("@/views/templates/payment/billPaymentMain"),
      meta: {
        roles: ["login", "corp"],
      },
    },
    {
      path: "paymentHistory",
      name: "paymentHistory3",
      description: "결제내역",
      component: () => import("@/views/templates/payment/paymentHistory"),
      meta: {
        roles: ["login"],
        svcDstcd: "1",
      },
    },
  ],
};

export default payment;
